import Box from '@mui/material/Box';
import Slider from '@mui/material/Slider';
import musicPlayer from '../services/audio/music-player';
import { useDispatch, useSelector } from 'react-redux';
import { setMusicVolume } from '../store/entities/game-controls/music-volume-slice';

export default function MusicSlider() {
  function preventHorizontalKeyboardNavigation(event) {
    if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
      event.preventDefault();
    }
  }

  const MIN_VOLUME = 0;  // Set your minimum value
  const MAX_VOLUME = 0.5;  // Set your maximum value

  const volume = useSelector(s => s.musicVolume);

  const dispatch = useDispatch();

  const handleChange = (event, newValue) => {
    musicPlayer.volume('rr_trafficambience_loop',newValue);
    dispatch(setMusicVolume(newValue));
  };

  return (
    <Box className="music-slider">
      <Slider
        sx={{
          '& input[type="range"]': {
            WebkitAppearance: 'slider-vertical',
          },
        }}
        orientation="vertical"
        value={volume}
        aria-label="Temperature"
        valueLabelDisplay="off"
        onKeyDown={preventHorizontalKeyboardNavigation}
        onChange={handleChange}
        min={MIN_VOLUME}
        max={MAX_VOLUME}
        step={0.001} // Optional: allows more granular control
      />
    </Box>
  );
}
